import { render, staticRenderFns } from "./CentreDetails.vue?vue&type=template&id=1cbd9df8&scoped=true"
import script from "./CentreDetails.vue?vue&type=script&lang=js"
export * from "./CentreDetails.vue?vue&type=script&lang=js"
import style0 from "./CentreDetails.vue?vue&type=style&index=0&id=1cbd9df8&prod&scoped=true&lang=css"
import style1 from "./CentreDetails.vue?vue&type=style&index=1&id=1cbd9df8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbd9df8",
  null
  
)

export default component.exports